export enum SeverityEnum {
  Critical = 'critical',
  High = 'high',
  Moderate = 'moderate',
  Medium = 'medium',
  Low = 'low',
}
